import React, {useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import PropTypes from 'prop-types';
import Input from "@material-ui/core/Input/Input";
import {withSnackbar} from "notistack";

function ViewSharedLinkDialog(props) {
    
    const [open, setOpen] = useState(true)
    const [textArea, setTextArea] = useState()

    const handleCloseDialog = () => {
        setOpen(false)
        props.handleCloseMenu && props.handleCloseMenu()
        props.handleCloseDialog && props.handleCloseDialog()
    };

    const copyToClipboard = (e) => {
        textArea.select();
        document.execCommand('copy');
        e.target.focus();
        props.enqueueSnackbar("URL copied to clipboard", {variant: 'success'});
        handleCloseDialog();
    };
    

    return (
        <div>
            <Dialog
                open={open}
                onClose={handleCloseDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogContent>
                    <DialogContentText>
                        Use the URL below to access the shared link for this document
                    </DialogContentText>
                    <br/>

                    <Input
                        id = "fileLink"
                        name = "fileLink"
                        value = {props.sharedLink}
                        inputRef = {(textarea) => setTextArea(textarea)}
                        type = "text"
                        margin="none"
                        variant="outlined"
                        readOnly={true}
                        style={{width: "100%"}}
                        autoFocus={true}
                        onFocus={event => {event.target.select()}}
                    />

                </DialogContent>

                <DialogActions>
                    <Button onClick={copyToClipboard}
                            variant="contained"
                            color="secondary">
                        Copy to Clipboard
                    </Button>
                    <Button onClick={handleCloseDialog}
                            variant="contained"
                            color="secondary">
                        Close
                    </Button>

                </DialogActions>
            </Dialog>
        </div>
    );
}

ViewSharedLinkDialog.propTypes = {
    classes: PropTypes.object,
    sharedLink: PropTypes.string.isRequired,
    handleCloseDialog: PropTypes.func.isRequired,
    handleCloseMenu: PropTypes.func
};


export default withSnackbar(ViewSharedLinkDialog);